import HeroBreadcrumb from "../components/HeroBreadcrumb"
import * as React from "react"
import {Link, graphql, PageProps} from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

type DataProps = {
    site: {
        buildTime: string
    }
}

const Exercises: React.FC<PageProps<DataProps>> = ({
                                                       data,
                                                       path,
                                                       location,
                                                   }) => {
    const posts = (data as any).allMarkdownRemark.nodes
    const filteredPosts = posts;
    return (
        <Layout location={location} title={"Site map of all our posts"}>
            <Seo title="All posts"/>
            <HeroBreadcrumb pageTitle="Sitemap"/>

            <div style={{maxWidth: "700px", margin: "40px auto"}}>
                <ol style={{listStyle: `none`}}>
                    {
                        filteredPosts.map(
                            link => <li key={link.fields.slug}><Link to={`${link.fields.slug}`}>
                                {link.frontmatter.title}</Link></li>
                        )
                    }
                </ol>
            </div>
        </Layout>
    );
}

export default Exercises

export const query = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___title], order: ASC }) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          isExercise
          exerciseTitle
          title
          description
        }
      }
    }
  }
`
